import { Link } from 'react-router-dom';
import { SideBarData } from '../mock/sidebar';
import { BsArrowRightCircleFill } from 'react-icons/bs';
import useLongPress from '../hook/useLongPress';
import MyForm from '../components/MyForm';

const Home = () => {
	const onLongPress = () => {
		console.log('longpress is triggered');
	};

	const onClick = () => {
		console.log('click is triggered');
	};

	const defaultOptions = {
		shouldPreventDefault: true,
		delay: 500,
	};

	const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);

	return (
		<div className="h-full overflow-y-hidden w-full flex items-center justify-center flex-col gap-[20px]">
			<button
				className="border px-4 py-3 rounded-md hover:bg-white hover:text-black"
				{...longPressEvent}
			>
				Long Press
			</button>
			<h1 className="text-4xl font-bold">OPTIMIZED REACT</h1>
			<p className="text-xl text-center">
				This site contains Optimization Techniques for React, React Hook, Redux
				Toolkit, React Query and TypeScript and Javascript Algorithms.
			</p>
			<Link
				to={SideBarData[0]?.link!}
				className="bg-gray-700 px-3 py-2 mt-5 rounded-md font-[600] text-sm hover:bg-gray-600 transition-all duration-700 ease-in-out flex items-center gap-2 group"
			>
				Let Get Started{' '}
				<BsArrowRightCircleFill
					size={19}
					className="group-hover:ml-2 transition-all duration-300 ease-in-out"
				/>
			</Link>
		</div>
	);
};

export default Home;
